import React from 'react';

interface CrossedContainerProps {
  isDeleted: boolean;
  children: React.ReactNode;
}

export const CrossedContainer: React.FC<CrossedContainerProps> = ({
  isDeleted,
  children,
}) => (
  <div style={{ position: 'relative', width: '100%' }}>
    {isDeleted && (
      <>
        <div
          style={{
            position: 'absolute',
            top: '3%',
            left: '1%',
            width: '98%',
            height: '94%',
            pointerEvents: 'none',
            zIndex: 1,
            background:
              'linear-gradient(to bottom right, transparent calc(50% - 1px), rgba(0, 0, 0, 0.4) calc(50% - 1px), rgba(0, 0, 0, 0.4) calc(50% + 1px), transparent calc(50% + 1px))',
          }}
        />

        <div
          style={{
            position: 'absolute',
            top: '3%',
            left: '1%',
            width: '98%',
            height: '94%',
            pointerEvents: 'none',
            zIndex: 1,
            background:
              'linear-gradient(to top right, transparent calc(50% - 1px), rgba(0, 0, 0, 0.4) calc(50% - 1px), rgba(0, 0, 0, 0.4) calc(50% + 1px), transparent calc(50% + 1px))',
          }}
        />
      </>
    )}
    {children}
  </div>
);
